import { IProject } from './projects.types'
import config from '../../config'
import accessTokenService from 'services/accessToken'
import { IEvent } from 'screens/Admin/Events/events.types'

const generateEmptyProject = () => ({
  techStack: '',
  expectingResults: '',
  motivation: '',
  repositoryLink: '',
  taskTrackingLink: '',
  description: '',
  name: '',
  eventId: null,
  keyTechnologies: [],
})

const generateEmptyProjectAdmin = () => ({
  techStack: '',
  expectingResults: '',
  motivation: '',
  repositoryLink: '',
  taskTrackingLink: '',
  description: '',
  name: '',
  eventId: null,
  keyTechnologies: [],
  adminOnly: false,
  teamsTargetCount: 1,
  minEducationYear: 1,
  maxEducationYear: 5,
  projectTypeId: null,
})

const getImageLink = (id: IProject['id']) =>
  `${config.API_URL}/nsi/v1/projects/${id}/image/raw?accessToken=${accessTokenService.get()}`

/**
 * Проверяет, активное ли событие у проекта
 * @param project
 * @param eventsMap
 * @returns
 */
const isActiveProject = (project: Pick<IProject, 'eventId'>, eventsMap: Record<number, IEvent>): boolean => {
  const event = eventsMap[project.eventId]
  return (
    new Date(event?.endsAt).getTime() > new Date().getTime() &&
    new Date(event?.startAt).getTime() < new Date().getTime()
  )
}

const projectsUtils = { generateEmptyProject, getImageLink, generateEmptyProjectAdmin, isActiveProject }
export default projectsUtils
